var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25853,
    cy: 3.87084,
    r: 3.37084,
    stroke: "white",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30576 12.6506C1.91618 10.2982 4.35015 9.19336 6.78042 9.19336H9.73523C12.1655 9.19336 14.5995 10.2982 15.2099 12.6506C15.3193 13.0723 15.4071 13.5242 15.46 14.0011C15.521 14.55 15.0679 14.9996 14.5156 14.9996H2C1.44771 14.9996 0.994679 14.55 1.05561 14.0011C1.10856 13.5242 1.19631 13.0723 1.30576 12.6506Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.e86c06cbc0e998ea7cb7e92fe2d56768.svg";
export { ForwardRef as ReactComponent };